import { HALFLING_RIG_VERSION, halflingProportions, halflingStandardHeight, morphHalflingProportions } from '../../../content/characters/rigs/halfling.js';
import type { UnitDefinition } from '../../../shared/game/world-types.js';
import { mix } from '../../../content/characters/rigs/human.js';
import { createHumanoidModel, type HumanModelOptions } from './human-model.js';

/** Halfling anatomy is a morph of the shared humanoid assembly; its head changes layer over the matching Human anatomy. */
export function createHalflingModel(definition: UnitDefinition, options?: HumanModelOptions) {
  const look = definition.appearance;
  if (!look || look.ancestry !== 'halfling') throw new Error('The Halfling model requires Halfling appearance content.');
  const p = morphHalflingProportions(halflingProportions(look.rig), look.parts?.face);
  const rig = createHumanoidModel({ ...definition, appearance: { ...look, height: look.height ?? halflingStandardHeight(p.id) } }, p, options,
    { face: p.face, palette: { eye: 0x7a6238, lips: mix(look.skin, 0x8a5246, .3) } });
  rig.root.userData.nimblezRigVersion = HALFLING_RIG_VERSION;
  return rig;
}
